export default "__VITE_ASSET__CuhT1AOJ__"